import { createFileRoute, redirect } from "@tanstack/react-router";
import { SETTINGS_REDIRECTS } from "@/features/settings/sections";

/** Old URL (ALP-84 P4): Appearance is now Settings → You → Preferences. */
export const Route = createFileRoute("/_app/settings/appearance")({
  beforeLoad: () => {
    throw redirect({ ...SETTINGS_REDIRECTS["/settings/appearance"], replace: true });
  },
});
